import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    amenities: any[];
    selectedAmenities: number[];
    setSelectedAmenities: (value: number[]) => void;
};

const AmenitiesSelector: React.FC<Props> = ({ amenities, selectedAmenities, setSelectedAmenities }) => {
    const { t } = useTranslation();

    const handleToggleAmenity = (id: number) => {
        if (selectedAmenities.includes(id)) {
            setSelectedAmenities(selectedAmenities.filter(aid => aid !== id));
        } else {
            setSelectedAmenities([...selectedAmenities, id]);
        }
    };

    return (
        <div className="w-full">
            <label className="block mb-2 text-sm font-medium text-gray-700">
                {t('amenities')}
            </label>
            <div className="grid grid-cols-2 gap-2">
                {amenities.map((amenity) => (
                    <label
                        key={amenity.id}
                        className="flex items-center gap-2 cursor-pointer border rounded-lg px-3 py-2 hover:bg-gray-100"
                    >
                        <input
                            type="checkbox"
                            checked={selectedAmenities.includes(amenity.id)}
                            onChange={() => handleToggleAmenity(amenity.id)}
                        />
                        <div className=' flex items-center gap-1'>
                            <div className=' w-8 h-8'>
                                <img className=' w-full' src={amenity.image} alt="service-image " />
                            </div>

                            <p>{amenity.title}</p>
                        </div>
                    </label>
                ))}
            </div>
        </div>
    );
};

export default AmenitiesSelector;
